import Constants from "@usas/ui-web/utils/Constants";
import { formatDate } from "@usas/ui-web/utils/DateFunctions";
import { isValidDate, isValidDateTime, isValidNumber } from "@usas/ui-web/utils/validation";

export const localValidate = (formState) => {
  let errors = {};

  const meetStartDate = new Date(formState.meetStartDate);
  const publishDate = new Date(formState.publishDate);

  const meetEntryStartDate = new Date(formState.meetEntryStartDate);
  const meetEntryEndDate = new Date(formState.meetEntryEndDate);
  const meetEntryChangeDeadline = new Date(formState.meetEntryChangeDeadline);

  //OME Meet Name
  if (formState.omeMeetName.trim() === '') {
    errors.omeMeetName = 'OME Meet Name is required'
  } else if (formState.omeMeetName.trim().length > 200) {
    errors.omeMeetName = 'OME Meet Name cannot exceed 200 characters'
  }

  //Main OME Meet?
  if (formState.isMainEntry !== true && formState.isMainEntry !== false) {
    errors.isMainEntry = 'A selection is required'
  }

  //Meet Entry Start Date
  //Must be before Meet Entry End Date and Meet Start Date
  if (formState.meetEntryStartDate.trim() === Constants.BLANK_DATETIME_STRING) {
    errors.meetEntryStartDate = 'Meet Entry Start Date is required'
  } else if (!isValidDateTime(formState.meetEntryStartDate)) {
    errors.meetEntryStartDate = 'Meet Entry Start Date must be a valid date and time'
  } else if (publishDate > meetEntryStartDate) {
    errors.meetEntryStartDate = `Meet Entry Start Date must be on or after the Meet Publish Date (${formatDate(publishDate)})`
  } else if (meetEntryStartDate >= meetStartDate) {
    errors.meetEntryStartDate = 'Meet Entry Start Date must be before the Meet Start Date'
  } else if (meetEntryEndDate <= meetEntryStartDate) {
    errors.meetEntryStartDate = 'Meet Entry Start Date must be before the Meet Entry End Date'
  }

  //Meet Entry End Date
  //Must be after Meet Entry Start Date and before Meet Start Date
  if (formState.meetEntryEndDate.trim() === Constants.BLANK_DATETIME_STRING) {
    errors.meetEntryEndDate = 'Meet Entry End Date is required'
  } else if (!isValidDateTime(formState.meetEntryEndDate)) {
    errors.meetEntryEndDate = 'Meet Entry End Date must be a valid date and time'
  } else if (meetEntryEndDate >= meetStartDate) {
    errors.meetEntryEndDate = 'Meet Entry End Date must be before the Meet Start Date'
  } else if (meetEntryEndDate <= meetEntryStartDate) {
    errors.meetEntryEndDate = 'Meet Entry End Date must be after the Meet Entry Start Date'
  } else if (meetEntryChangeDeadline < meetEntryEndDate) {
    errors.meetEntryEndDate = 'Meet Entry End Date must be on or before the Meet Entry Change Deadline'
  }

  //Meet Entry Change Deadline 
  // Must be before Meet Start Date and after the Meet Entry Start Date
  if (formState.meetEntryChangeDeadline.trim() === Constants.BLANK_DATETIME_STRING) {
    errors.meetEntryChangeDeadline = 'Meet Entry Change Deadline is required'
  } else if (!isValidDateTime(formState.meetEntryChangeDeadline)) {
    errors.meetEntryChangeDeadline = 'Meet Entry Change Deadline must be a valid date and time'
  } else if (meetEntryChangeDeadline >= meetStartDate) {
    errors.meetEntryChangeDeadline = 'Meet Entry Change Deadline must be before the Meet Start Date'
  } else if (meetEntryChangeDeadline < meetEntryEndDate) {
    errors.meetEntryChangeDeadline = 'Meet Entry Change Deadline must be on or after the Meet Entry End Date'
  }

  if (formState.maxNumberOfAthletesForMeet !== '' && formState.isMainEntry === false && formState.maxNumberOfAthletesCountsTowardsMainOmeMeet !== false &&
    formState.maxNumberOfAthletesCountsTowardsMainOmeMeet !== true) {
    errors.maxNumberOfAthletesCountsTowardsMainOmeMeet = 'A selection is required when a Max Number of Athletes For Meet is provided and the OME Meet is not the Main OME Meet';
  }

  if (formState.maxNumberOfAthletesForMeet === '' && formState.isMainEntry === false && formState.maxNumberOfAthletesCountsTowardsMainOmeMeet === true) {
    errors.maxNumberOfAthletesForMeet = `A 'Max Number of Athletes For Meet' is required when the 'Count Max # of Athletes towards Main OME Meet Cap?' switch is set to 'Yes'`;
  }

  if (formState.relayEvents === true && formState.allowRelayOnlySwimmer === true && formState.maxNumberOfAthletesForMeet !== '' && formState.includeRelayOnlySwimmersInMaxNumber !== false &&
    formState.includeRelayOnlySwimmersInMaxNumber !== true) {
    errors.includeRelayOnlySwimmersInMaxNumber = 'A selection is required when a Max Number of Athletes For Meet is provided and the Meet has Relay Events and Allows Relay Only Swimmers';
  }

  if (formState.orgUnit.length === 0) {
    errors.orgUnit = 'At least one selection is required'
  }

  const timeStandardsQualifyingStartDate = new Date(formState.timeStandardsQualifyingStartDate);
  const timeStandardsQualifyingEndDate = new Date(formState.timeStandardsQualifyingEndDate);
  const meetEntryEndDateDateOnly = new Date(formState.meetEntryEndDate.substring(0, 10));

  if (formState.hasTimeStandards === true) {
    if (formState.hasQualifyingWindow !== true && formState.hasQualifyingWindow !== false) {
      errors.hasQualifyingWindow = 'A selection is required';
    }

    if (formState.hasQualifyingWindow === true) {
      //Qualifying Start Date
      if (formState.timeStandardsQualifyingStartDate === Constants.BLANK_DATE_STRING) {
        errors.timeStandardsQualifyingStartDate = 'Qualifying Start Date is required';
      } else if (timeStandardsQualifyingStartDate >= timeStandardsQualifyingEndDate) {
        errors.timeStandardsQualifyingStartDate = 'Qualifying Start Date must be before the Qualifying End Date'
      } else if (!isValidDate(formState.timeStandardsQualifyingStartDate)) {
        errors.timeStandardsQualifyingStartDate = 'Qualifying Start Date must be a valid date';
      }
      //Qualifying End Date
      if (formState.timeStandardsQualifyingEndDate === Constants.BLANK_DATE_STRING) {
        errors.timeStandardsQualifyingEndDate = 'Qualifying End Date is required';
      } else if (timeStandardsQualifyingStartDate >= timeStandardsQualifyingEndDate) {
        errors.timeStandardsQualifyingEndDate = 'Qualifying End Date must be after the Qualifying Start Date'
      } else if (timeStandardsQualifyingEndDate > meetEntryEndDateDateOnly) {
        errors.timeStandardsQualifyingEndDate = `Qualifying End Date must be on or before the Meet Entry End Date (${formState.meetEntryEndDate.substring(0, 10)})`
      } else if (!isValidDate(formState.timeStandardsQualifyingEndDate)) {
        errors.timeStandardsQualifyingEndDate = 'Qualifying End Date must be a valid date';
      }
    }
  }

  if (formState.costPerTeam !== '') {
    if (!isValidNumber(formState.costPerTeam)) {
      errors.costPerTeam = 'Cost Per Team must be a valid number';
    } else if (formState.costPerTeam < 0 || formState.costPerTeam > 500) {
      errors.costPerTeam = 'Cost Per Team must be between $0 and $500';
    }
  } else if (formState.costPerTeam === '') {
    errors.costPerTeam = 'Cost Per Team must be a valid number';
  }

  if (formState.costPerCredential !== '') {
    if (!isValidNumber(formState.costPerCredential)) {
      errors.costPerCredential = 'Cost Per Credential must be a valid number';
    } else if (formState.costPerCredential < 0 || formState.costPerCredential > 500) {
      errors.costPerCredential = 'Cost Per Credential must be between $0 and $500';
    }
  } else if (formState.costPerCredential === '') {
    errors.costPerCredential = 'Cost Per Credential must be a valid number';
  }

  if (formState.costPerIndividualAthlete !== '') {
    if (!isValidNumber(formState.costPerIndividualAthlete)) {
      errors.costPerIndividualAthlete = 'Cost Per Individual Athlete must be a valid number';
    } else if (formState.costPerIndividualAthlete < 0 || formState.costPerIndividualAthlete > 500) {
      errors.costPerIndividualAthlete = 'Cost Per Individual Athlete must be between $0 and $500';
    }
  } else if (formState.costPerIndividualAthlete === '') {
    errors.costPerIndividualAthlete = 'Cost Per Individual Athlete must be a valid number';
  }

  if (formState.showCostPerRelayOnlySwimmer === true && formState.costPerRelayOnlySwimmer !== '') {
    if (!isValidNumber(formState.costPerRelayOnlySwimmer)) {
      errors.costPerRelayOnlySwimmer = 'Cost Per Relay Only Swimmer must be a valid number';
    } else if (formState.costPerRelayOnlySwimmer < 0 || formState.costPerRelayOnlySwimmer > 500) {
      errors.costPerRelayOnlySwimmer = 'Cost Per Relay Only Swimmer must be between $0 and $500';
    }
  } else if (formState.showCostPerRelayOnlySwimmer === true && formState.costPerRelayOnlySwimmer === '') {
    errors.costPerRelayOnlySwimmer = 'Cost Per Relay Only Swimmer must be a valid number';
  }

  if (formState.showCostPerIndividualInternationalAthlete === true && formState.costPerIndividualInternationalAthlete !== '') {
    if (!isValidNumber(formState.costPerIndividualInternationalAthlete)) {
      errors.costPerIndividualInternationalAthlete = 'Cost Per Individual International Athlete must be a valid number';
    } else if (formState.costPerIndividualInternationalAthlete < 0 || formState.costPerIndividualInternationalAthlete > 500) {
      errors.costPerIndividualInternationalAthlete = 'Cost Per Individual International Athlete must be between $0 and $500';
    }
  } else if (formState.showCostPerIndividualInternationalAthlete === true && formState.costPerIndividualInternationalAthlete === '') {
    errors.costPerIndividualInternationalAthlete = 'Cost Per Individual International Athlete must be a valid number';
  }

  if (formState.showCostPerInternationalStaff === true && formState.costPerInternationalStaff !== '') {
    if (!isValidNumber(formState.costPerInternationalStaff)) {
      errors.costPerInternationalStaff = 'Cost Per International Staff must be a valid number';
    } else if (formState.costPerInternationalStaff < 0 || formState.costPerInternationalStaff > 500) {
      errors.costPerInternationalStaff = 'Cost Per International Staff must be between $0 and $500';
    }
  } else if (formState.showCostPerInternationalStaff === true && formState.costPerInternationalStaff === '') {
    errors.costPerInternationalStaff = 'Cost Per International Staff must be a valid number';
  }

  if (formState.costPerAthleteIndividualEventEntry === '' || !isValidNumber(formState.costPerAthleteIndividualEventEntry)) {
    errors.costPerAthleteIndividualEventEntry = 'Cost Per Athlete Individual Event Entry must be a valid number';
  } else if (formState.costPerAthleteIndividualEventEntry < 0 || formState.costPerAthleteIndividualEventEntry > 500) {
    errors.costPerAthleteIndividualEventEntry = 'Cost Per Athlete Individual Event Entry must be between $0 and $500';
  }

  if (formState.showCostPerAthleteIndividualBonusEventEntry === true && formState.costPerAthleteIndividualBonusEventEntry !== '') {
    if (formState.costPerAthleteIndividualBonusEventEntry !== '') {
      if (!isValidNumber(formState.costPerAthleteIndividualBonusEventEntry)) {
        errors.costPerAthleteIndividualBonusEventEntry = 'Cost Per Athlete Individual Bonus Event Entry must be a valid number';
      } else if (formState.costPerAthleteIndividualBonusEventEntry < 0 || formState.costPerAthleteIndividualBonusEventEntry > 500) {
        errors.costPerAthleteIndividualBonusEventEntry = 'Cost Per Athlete Individual Bonus Event Entry must be between $0 and $500';
      }
    }
  } else if (formState.showCostPerAthleteIndividualBonusEventEntry === true && formState.costPerAthleteIndividualBonusEventEntry === '') {
    errors.costPerAthleteIndividualBonusEventEntry = 'Cost Per Athlete Individual Bonus Event Entry must be a valid number';
  }

  if (formState.showCostPerRelayEventEntry === true && formState.costPerRelayEventEntry !== '') {
    if (!isValidNumber(formState.costPerRelayEventEntry)) {
      errors.costPerRelayEventEntry = 'Cost Per Relay Event Entry must be a valid number';
    } else if (formState.costPerRelayEventEntry < 0 || formState.costPerRelayEventEntry > 500) {
      errors.costPerRelayEventEntry = 'Cost Per Relay Event Entry must be between $0 and $500';
    }
  } else if (formState.showCostPerRelayEventEntry === true && formState.costPerRelayEventEntry === '') {
    errors.costPerRelayEventEntry = 'Cost Per Relay Event Entry must be a valid number';
  }


  return errors;
};

const OmeMeetsDetailValidationNonHQ = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};
export default OmeMeetsDetailValidationNonHQ;